import { Loading } from '@appd/uik';

export default function DashboardLoading() {
  return <Loading.Bar thin />;
}
